export default __webpack_public_path__ + "static/media/MISTRZ_ENERGII.0704b619.png";